import api from './api';

export const occasionsService = {
    async getOccasions(params = {}) {
        const response = await api.get('/occasions/occasions/', { params });
        return response.data;
    },

    async getOccasion(id) {
        const response = await api.get(`/occasions/occasions/${id}/`);
        return response.data;
    },

    async createOccasion(data) {
        const response = await api.post('/occasions/occasions/', data);
        return response.data;
    },

    async updateOccasion(id, data) {
        const response = await api.patch(`/occasions/occasions/${id}/`, data);
        return response.data;
    },

    async deleteOccasion(id) {
        await api.delete(`/occasions/occasions/${id}/`);
    },

    async getReminders(params = {}) {
        const response = await api.get('/occasions/reminders/', { params });
        return response.data;
    },

    async createReminder(data) {
        const response = await api.post('/occasions/reminders/', data);
        return response.data;
    },

    async updateReminder(id, data) {
        const response = await api.patch(`/occasions/reminders/${id}/`, data);
        return response.data;
    },

    async deleteReminder(id) {
        await api.delete(`/occasions/reminders/${id}/`);
    },

    async getUpcomingOccasions(days = 30) {
        const response = await api.get('/occasions/occasions/', {
            params: { upcoming_days: days }
        });
        return response.data;
    }
}; 